/** @jsx jsx */
import { Themed, jsx } from "theme-ui"

const Header = () => (
  <header sx={{ my: 4 }}>
    <Themed.h1>sty·lis·tic·'ponents</Themed.h1>
    <ul>
      <i>Have not synced our token yet, so styles on display by each stylistic docuponent is just filler.</i>
      <li><del>Color Families</del></li>
      <li><del>Color Row</del></li>
      <li><del>Color Swatch</del></li>
      <li><del>Palette: Color Rows</del></li>
      <li><del>Palette: Color Swatches</del></li>
      <li><del>Font Family</del></li>
      <li><del>Font Size</del></li>
      <li><del>Font Weight</del></li>
      <li><del>Heading / Type</del></li>
      <li><del>Space</del></li>
      <li>Downloadables</li>
      <li>Alert / Messaging</li>
      <li>Border Radius</li>
      <li><del>Sizes</del></li>
      <li>Shadows</li>

      <li>Video</li>
    </ul>
  </header>
)

export default Header
